import { captureError, configFromEnv, PlatformProvider } from '@hobbytools/platform';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { routes } from './routes';
import './styles.css';

const router = createBrowserRouter(routes, { basename: import.meta.env.BASE_URL });

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');
createRoot(root).render(
  <StrictMode>
    <PlatformProvider config={configFromEnv(import.meta.env)}>
      <RouterProvider router={router} onError={captureError} />
    </PlatformProvider>
  </StrictMode>,
);
